






import Vue from 'vue'
import Component from 'vue-class-component'
import devicePixelRatio from '@/common/devicePixelRatio.js'
export default {
  name: 'App',
  created() {
    // new devicePixelRatio().init()
  },
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue